import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse((localStorage.getItem('userInfo') && localStorage.getItem('userInfo') !== 'undefined') ? localStorage.getItem('userInfo') : '{}'),
    userType: parseInt(localStorage.getItem('userType')) || 0,
    hasCompletedOnboarding: localStorage.getItem('hasCompletedOnboarding') === 'true',
    achievementPopup: { visible: false, title: '', description: '', xp: 0, type: 'success' }
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info
      localStorage.setItem('userInfo', JSON.stringify(info))
    },
    SET_USER_TYPE(state, type) {
      state.userType = type
      localStorage.setItem('userType', String(type))
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.userInfo = {}
      state.userType = 0
      state.hasCompletedOnboarding = false
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('userType')
      localStorage.removeItem('hasCompletedOnboarding')
    },
    SET_ONBOARDING_DONE(state) {
      state.hasCompletedOnboarding = true
      localStorage.setItem('hasCompletedOnboarding', 'true')
    },
    SHOW_ACHIEVEMENT(state, payload) {
      state.achievementPopup = { ...payload, visible: true }
    },
    HIDE_ACHIEVEMENT(state) {
      state.achievementPopup.visible = false
    }
  },
  actions: {
    login({ commit }, { token, userInfo }) {
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', userInfo)
      commit('SET_USER_TYPE', userInfo.userType)
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
      router.push('/login').catch(() => {})
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    isStudent: state => state.userType === 1,
    isTeacher: state => state.userType === 2,
    isAdmin: state => state.userType === 3
  }
})